// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New medical machine (Stitch: New medical machine) ——— */
.machine-form-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  background: #ffffff;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.machine-form-page__crumbbar {
  box-sizing: border-box;
  padding: 16px 24px;
  border-bottom: 1px solid #E2E8F0;
}

.machine-form-page__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  line-height: 1.3;
}

.machine-form-page__crumb {
  color: #64748B;
  text-decoration: none;
  transition: color 0.12s ease;
}

.machine-form-page__crumb:hover {
  color: #0EA5E9;
}

.machine-form-page__crumb--muted {
  pointer-events: none;
}

.machine-form-page__crumb--current {
  color: #0F172A;
  font-weight: 600;
}

.machine-form-page__sep {
  color: #CBD5E1;
}

.machine-form-page__header {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px 32px;
  border-bottom: 1px solid #E2E8F0;
}

.machine-form-page__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
}

.machine-form-page__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .machine-form-page__back .lucide {
  transform: scaleX(-1);
}

.machine-form-page__heading {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.machine-form-page__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.machine-form-page__subtitle {
  margin: 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.45;
}

.machine-form-page__body {
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: none;
  padding: 24px 32px 32px;
}

.machine-form-page__body > .machine-form {
  width: 100% !important;
  max-width: none !important;
  align-self: stretch;
}

.machine-form-page__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  max-width: none;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #E2E8F0;
}

.machine-form-page__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.machine-form-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.machine-form-page__btn--ghost {
  height: 34px;
  padding: 0 16px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-weight: 500;
}

.machine-form-page__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
}

.machine-form-page__btn--primary {
  height: 38px;
  padding: 0 20px;
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.machine-form-page__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 720px) {
  .machine-form-page__header,
  .machine-form-page__body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .machine-form-page__footer {
    justify-content: stretch;
  }

  .machine-form-page__btn {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewMedicalMachine/style.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ——— New medical machine (Stitch: New medical machine) ——— */\n.machine-form-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  background: #ffffff;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.machine-form-page__crumbbar {\n  box-sizing: border-box;\n  padding: 16px 24px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.machine-form-page__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.machine-form-page__crumb {\n  color: #64748B;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.machine-form-page__crumb:hover {\n  color: #0EA5E9;\n}\n\n.machine-form-page__crumb--muted {\n  pointer-events: none;\n}\n\n.machine-form-page__crumb--current {\n  color: #0F172A;\n  font-weight: 600;\n}\n\n.machine-form-page__sep {\n  color: #CBD5E1;\n}\n\n.machine-form-page__header {\n  box-sizing: border-box;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 24px 32px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.machine-form-page__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.machine-form-page__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .machine-form-page__back .lucide {\n  transform: scaleX(-1);\n}\n\n.machine-form-page__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.machine-form-page__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.machine-form-page__subtitle {\n  margin: 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.45;\n}\n\n.machine-form-page__body {\n  box-sizing: border-box;\n  flex: 1;\n  width: 100%;\n  max-width: none;\n  padding: 24px 32px 32px;\n}\n\n.machine-form-page__body > .machine-form {\n  width: 100% !important;\n  max-width: none !important;\n  align-self: stretch;\n}\n\n.machine-form-page__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: none;\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.machine-form-page__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.machine-form-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.machine-form-page__btn--ghost {\n  height: 34px;\n  padding: 0 16px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-weight: 500;\n}\n\n.machine-form-page__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.machine-form-page__btn--primary {\n  height: 38px;\n  padding: 0 20px;\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.machine-form-page__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 720px) {\n  .machine-form-page__header,\n  .machine-form-page__body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .machine-form-page__footer {\n    justify-content: stretch;\n  }\n\n  .machine-form-page__btn {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
